import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const MagneticCircuits = () => (
  <QPhototModuleSubtopic
    title="Magnetic Circuits"
    videos={[
      "https://www.youtube.com/embed/EE_LAIIuXsQ",
      "https://www.youtube.com/embed/HZb3EGXqjoQ",
      "https://www.youtube.com/embed/6FVZDuogL4M",
      "https://www.youtube.com/embed/g1v7KUTLVnM"
    ]}
    takeaways={[
      { text: "Practice more problems." },
      { text: "Air-gap questions are mostly asked." },
      { text: "Know all the terms properly without confusion like mean length, cross section etc." }
    ]}
    questions={[
      { image: "/beee_23.jpeg" },
      { image: "/beee_24.jpeg" },
      { image: "/beee_25.jpeg" },
      { image: "/beee_26.jpeg" },
      { image: "/beee_27.jpeg" },
      { image: "/beee_28.jpeg" },
      { image: "/beee_29.jpeg" },
      { image: "/beee_30.jpeg" },
      { image: "/beee_31.jpeg" }
    ]}
    exampleVideos={[]}
  />
);

export default MagneticCircuits;
